import React, {useEffect, useState} from 'react';
import {Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import {getAnalysisModService, getAnalysisService} from "../../../services/app.service";
import {ANALYSIS_TYPES} from "../../../utils/constants";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import AnalysisChart from "./AnalysisChart.comp";
import {asciiSortCompareFunWithKey} from "../../../utils/utils";
import Box from "@material-ui/core/Box";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {useLevel3} from "../hooks/useLevel3.hook";

function Level5AnalysisComp(props) {

    const {application_id, reload} = props;

    const [analysis, setAnalysis] = useState({});
    const [loading, setLoading] = useState(false);
    const [LEVEL3, setLEVEL3] = useState({});
    useLevel3(onSetLevel3)

    function onSetLevel3(object) {
        setLEVEL3(object);
    }
    async function fetchAnalysis() {
        try {
            setLoading(true);
            const result = await getAnalysisService(application_id, ANALYSIS_TYPES.LEVEL_5_ANALYSIS);
            if(!result.error) {
                setAnalysis(result.data);
                console.log(result.data);
            }
            setLoading(false);
        }
        catch (e) {
            console.error(e);
            // already toasted the error
            setLoading(false);
        }
    }

    function getDQC(dqc_no) {
        const dq_num = parseInt(dqc_no.replace("DQC", ""), 10);
        const code = isNaN(dq_num) ? dqc_no : `DQ${dq_num}`
        const title = dqc_no;
        const color = LEVEL3[code] ? LEVEL3[code].color : "#444"
        return {code, title, color};
    }

    useEffect(() => {
        fetchAnalysis().then();
    }, [reload])

    return <>
        <br/>
            <Grid container spacing={2}>
                <Grid item>
                    <TextField id='assumption1' variant="outlined" label={'Discount rate'} value={analysis.assumption1 ? `${analysis.assumption1}%` : ""} InputProps={{readOnly: true}}/>
                </Grid>
            </Grid>
        <br/>
        {
            analysis.data &&
            <Box width={400} height={400} ml={'auto'} mr={'auto'}>
                <AnalysisChart
                    analysis={analysis.data.sort(asciiSortCompareFunWithKey('dqc_no')).map((item) => ({
                        ...item,
                        ...getDQC(item.dqc_no)
                    }))}
                />
            </Box>
        }
        <br/>
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>DQC#</TableCell>
                        <TableCell>Count of Message</TableCell>
                        <TableCell>Percentage</TableCell>
                        <TableCell>DQC# Percentage</TableCell>
                        <TableCell>Discount Percentage</TableCell>
                        <TableCell>Discount Amount</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        analysis.data && analysis.data.map((item) =>
                            <TableRow>
                                <TableCell>{item.dqc_no}</TableCell>
                                <TableCell>{item.count}</TableCell>
                                <TableCell>{item.percent}%</TableCell>
                                <TableCell>{item.dqc_percent}%</TableCell>
                                <TableCell>{item.discount_percent}%</TableCell>
                                <TableCell>{item.discount_amount}</TableCell>
                            </TableRow>
                        )
                    }
                    {
                        analysis.grand_total &&
                        <TableRow>
                            <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.dqc_no}</TableCell>
                            <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.count}</TableCell>
                            <TableCell style={{fontWeight: "bold"}}>{analysis.grand_total.percent}%</TableCell>
                            <TableCell style={{fontWeight: "bold"}}/>
                            <TableCell style={{fontWeight: "bold"}}/>
                            <TableCell style={{fontWeight: "bold"}}/>
                        </TableRow>
                    }
                </TableBody>
            </Table>
            <LoaderWithBackDrop loading={loading}/>
        </TableContainer>
    </>
}

export default Level5AnalysisComp;